import { useMutation } from "@tanstack/vue-query";
import { toast } from "vue3-toastify";
import { axios_instance } from "./api";

interface UpdateHistoryParams {
  page: number;
  size: number;
  campaign_id: string;
  agent_id: string;
}

interface CreateUpdateCommandParams {
  agent_id: string;
  campaign_id: string;
  version_id: string;
}

interface UpdateHistoryItem {
  id: string;
  created: number;
  modified: number;
  completed: number;
  campaign: string;
  status: string;
  is_campaign: boolean;
  version: string;
  agent_must_update: string[] | null;
  agent_updated: string[] | null;
}

interface UpdateHistoryResponse {
  data: UpdateHistoryItem[];
  message: string;
  total_filter: number;
}

export const fetchUpdateHistory = async (
  params: UpdateHistoryParams,
): Promise<UpdateHistoryResponse> => {
  const { page, size, campaign_id, agent_id } = params;
  const data = JSON.stringify({
    page,
    size,
    campaign_id,
    agent_id,
    type: campaign_id ? ["campaign"] : [],
  });

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: "/api/v1/view/action/history/update-agent",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  const response = await axios_instance.request<UpdateHistoryResponse>(config);
  return response.data;
};

export const createUpdateCommand = async (
  params: CreateUpdateCommandParams,
): Promise<void> => {
  const { agent_id, campaign_id, version_id } = params;
  const data = JSON.stringify({
    agent_id,
    campaign_id,
    version_id,
  });

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: "/api/v1/view/action/update-agent",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios_instance.request(config);
    toast.success("Tạo lệnh cập nhật thành công!");
    return response.data;
  } catch (error) {
    toast.error("Tạo lệnh cập nhật thất bại!");
    throw error;
  }
};

export const useCreateUpdateCommandMutation = () => {
  return useMutation<void, Error, CreateUpdateCommandParams>({
    mutationFn: (params: CreateUpdateCommandParams) =>
      createUpdateCommand(params),
  });
};
